// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageFI = {
  seo: {
    title: 'Tekoälyn läpinäkyvyys | pAIoneer Labs GmbH',
    description: 'Miten pAIoneer Labs GmbH käyttää tekoälyä ja tiedottaa siitä: tekoälyavustaja, tekoälyn tuottaman sisällön merkitseminen, toimituksellinen vastuu ja yhteyshenkilö tekoälyasetuksen mukaisesti.',
    keywords: 'tekoälyn läpinäkyvyys, tekoälyasetus, AI Act, 50 artikla, merkitseminen, tekoälyavustaja, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Tekoälyn läpinäkyvyys',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Tekoälyn läpinäkyvyys',
    subtitle: 'Miten pAIoneer Labs GmbH käyttää tekoälyä ja tiedottaa siitä.'
  },
  sections: [
    {
      title: 'Oikeudellinen kehys',
      paragraphs: [
        'Tekoälystä annetun asetuksen (EU) 2024/1689 (tekoälyasetus) 50 artiklan mukaisia läpinäkyvyysvelvoitteita sovelletaan 2. elokuuta 2026 alkaen. Saksassa Bundesnetzagentur (Saksan liittovaltion verkkovirasto) on KI-Marktüberwachungs- und Innovationsförderungsgesetz -lain (KI-MIG, Saksan laki tekoälyn markkinavalvonnasta ja innovaatioiden edistämisestä) nojalla tekoälyasetuksen markkinavalvontaviranomainen ja valituksia käsittelevä taho.',
        'Tällä sivulla kuvataan, mitä tekoälyjärjestelmiä pAIoneer Labs GmbH käyttää ja miten se tiedottaa niistä. Sitä, miten henkilötietoja tällöin käsitellään, kuvataan tietosuojaselosteessa.'
      ]
    },
    {
      title: 'Tekoälyavustaja sovelluksessamme',
      paragraphs: [
        'Sovelluksessamme tekoälyavustaja vastaa kysymyksiisi. Se on tekoälyjärjestelmä: sen vastaukset tuotetaan automaattisesti kielimalleilla, ja ne voivat olla virheellisiä. Tarkista tärkeät tiedot ennen kuin perustat niihin päätöksiä.',
        'Sovellus kertoo tästä ennen ensimmäistä syötettäsi ja pysyvästi chatin vieressä (tekoälyasetuksen 50 artiklan 1 kohta). Lisäksi jokainen avustajan vastaus on merkitty koneluettavasti tekoälyn tuottamaksi (tekoälyasetuksen 50 artiklan 2 kohta).',
        'Kielimallit tarjotaan yhdysvaltalaisen OpenRouter, Inc. -yhtiön palvelun kautta.'
      ]
    },
    {
      title: 'Suora viestintä tekoälyjärjestelmien kanssa',
      paragraphs: [
        'Kun pAIoneer Labs GmbH:n tekoälyjärjestelmä viestii suoraan kanssasi, esimerkiksi chatissa, se ilmoittaa olevansa tekoälyjärjestelmä viimeistään ensimmäisen vuorovaikutuksen yhteydessä.'
      ]
    },
    {
      title: 'Tämän verkkosivuston sisältö',
      paragraphs: [
        'pAIoneer Labs GmbH tarkistaa tämän verkkosivuston tekstit – myös silloin, kun tekoälytyökalut avustavat niiden laatimisessa – ja julkaisee ne toimituksellisella vastuullaan (tekoälyasetuksen 50 artiklan 4 kohdan toinen alakohta).',
        'Tekoälyllä tuotetun tai muokatun kuva-, ääni- tai videosisällön, joka esittää todellisia henkilöitä, paikkoja tai tapahtumia harhaanjohtavan aidon oloisesti, merkitsemme keinotekoisesti tuotetuksi tai muokatuksi (tekoälyasetuksen 50 artiklan 4 kohdan ensimmäinen alakohta).'
      ]
    },
    {
      title: 'Analyysi koneoppimisen avulla',
      paragraphs: [
        'Suostumuksellasi analysoimme käyntitilastoja koneoppimismenetelmillä; yksityiskohdat ovat tietosuojaselosteessa. Emme käytä tässä tunteentunnistusta emmekä biometristä luokittelua (tekoälyasetuksen 50 artiklan 3 kohta). Ihmisten ja automatisoitujen käyntien erottaminen perustuu laitteen, selaimen ja yhteyden teknisiin ominaisuuksiin, ei biometrisiin tietoihin.'
      ]
    },
    {
      title: 'Valitus',
      paragraphs: [
        'Voit tehdä valituksen tekoälyasetuksen mahdollisesta rikkomisesta Bundesnetzagenturille, joka on tekoälyasetuksen markkinavalvontaviranomainen ja valituksia käsittelevä taho Saksassa. Se tarjoaa tästä tietoa osoitteessa bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Yhteystiedot',
    description: 'Tekoälyn käyttöä koskevissa kysymyksissä tavoitat meidät sähköpostitse.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Päivitetty: 30. lokakuuta 2026. Saksankielinen versio on sitova.'
};
